import type { IDepositRow, INsuRow } from "src/@types/deposit-reconciliation";

import { formatToBRL } from "@/utils/formatToMoney";

import { DEPOSIT_STATUS } from "../../constants/status";

export type ItemVariant = "free" | "draft" | "reconciled";

const NO_ADJUSTMENT_PLACEHOLDER = "—";

export function formatNsuAdjustment(nsu: INsuRow): string {
  if (nsu.adjustmentAmount === 0) return NO_ADJUSTMENT_PLACEHOLDER;
  return formatToBRL(nsu.adjustmentAmount);
}

const NSU_AMOUNT_CLASS = {
  REPLACED_BY_ADJUSTMENT: "text-xs whitespace-nowrap line-through opacity-70",
  DEFAULT: "text-xs whitespace-nowrap",
} as const;

export function nsuAmountClass(nsu: INsuRow): string {
  if (nsu.adjustmentAmount === 0) return NSU_AMOUNT_CLASS.DEFAULT;
  return NSU_AMOUNT_CLASS.REPLACED_BY_ADJUSTMENT;
}

const ITEM_ROW_CLASS = {
  DRAFT: "bg-yellow-50 opacity-70 line-through",
  NOT_SELECTABLE: "bg-blue-50 opacity-80",
  SELECTED: "bg-emerald-50",
  DEFAULT: "hover:bg-slate-50",
} as const;

export function itemRowClass(
  isInDraft: boolean,
  selectable: boolean,
  isSelected: boolean,
): string {
  if (isInDraft) return ITEM_ROW_CLASS.DRAFT;
  if (!selectable) return ITEM_ROW_CLASS.NOT_SELECTABLE;
  if (isSelected) return ITEM_ROW_CLASS.SELECTED;
  return ITEM_ROW_CLASS.DEFAULT;
}

export function isDepositSelectable(deposit: IDepositRow): boolean {
  return deposit.status === DEPOSIT_STATUS.PENDING && !deposit.isInDraft;
}

export function depositVariantOf(deposit: IDepositRow): ItemVariant {
  if (deposit.status === DEPOSIT_STATUS.RECONCILED && deposit.batchId) {
    return "reconciled";
  }
  if (deposit.isInDraft) return "draft";
  return "free";
}

export function isNsuSelectable(nsu: INsuRow): boolean {
  return !nsu.isReconciled && !nsu.isInDraft;
}

export function nsuVariantOf(nsu: INsuRow): ItemVariant {
  if (nsu.isReconciled && nsu.batchId) return "reconciled";
  if (nsu.isInDraft) return "draft";
  return "free";
}
